export const MAX_FETCH_ATTEMPTS_LIMIT = 10;
